// extracted by mini-css-extract-plugin
export default {"welcomeSection":"WelcomeSection_welcomeSection__nZ3hS"};